module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/shadow.9781fccd.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/shadow.png
// module id = 3491
// module chunks = 11